import { render, staticRenderFns } from "./CommissionEditor.vue?vue&type=template&id=79bf40ab&scoped=true"
import script from "./CommissionEditor.vue?vue&type=script&lang=js"
export * from "./CommissionEditor.vue?vue&type=script&lang=js"
import style0 from "./CommissionEditor.vue?vue&type=style&index=0&id=79bf40ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bf40ab",
  null
  
)

export default component.exports